import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DbGlyph = /*#__PURE__*/createElement("g", {
  id: "db-icon"
}, /*#__PURE__*/createElement("path", {
  d: "M65.49 27.15c-.28-5.52-11.95-8.42-23.49-8.42s-23.21 2.89-23.49 8.42h-.01v29.49c0 5.66 11.82 8.62 23.5 8.62s23.5-2.96 23.5-8.62V27.15h-.01zM42 21.74c12.51 0 20.5 3.33 20.5 5.62s-7.99 5.62-20.5 5.62-20.5-3.33-20.5-5.62c0-2.3 7.99-5.62 20.5-5.62zm0 40.52c-12.51 0-20.5-3.33-20.5-5.62v-5.32c4.25 2.76 12.41 4.18 20.5 4.18s16.25-1.42 20.5-4.18v5.32c0 2.3-7.99 5.62-20.5 5.62zm0-9.76c-12.51 0-20.5-3.33-20.5-5.62v-5.32c4.25 2.76 12.41 4.18 20.5 4.18s16.25-1.42 20.5-4.18v5.32c0 2.29-7.99 5.62-20.5 5.62zm0-9.76c-12.51 0-20.5-3.33-20.5-5.62V31.8c4.25 2.76 12.41 4.18 20.5 4.18s16.25-1.42 20.5-4.18v5.32c0 2.29-7.99 5.62-20.5 5.62z"
}));
const Db = createSvg({
  name: 'db',
  path: DbGlyph
});

export default Db;
export { DbGlyph };
